import React, { FC } from 'react'
import { ProductNameCell } from './ProductNameCell'
import StatusButton from 'src/app/pages/orders/StatusButton'
import { currencySigns } from 'src/utils/constants'

interface EnhancedCellProps {
  value: any
  type?: 'text' | 'status' | 'productName' | 'price' | 'badge' | 'date'
  currency?: string
  platformCurrency?: string
  row?: any
  syncMessage?: string
}

export const EnhancedCell: FC<EnhancedCellProps> = ({ 
  value, 
  type = 'text', 
  currency,
  platformCurrency,
  row,
  syncMessage,
}) => {
  const normalizeCurrencyCode = (rawCurrency?: string) => {
    const raw = String(rawCurrency || '')
      .trim()
      .toUpperCase()
    if (!raw) return ''

    const aliasMap: Record<string, string> = {
      POUND: 'GBP',
      POUNDS: 'GBP',
      GB: 'GBP',
      UK: 'GBP',
      UKP: 'GBP',
      DOLLAR: 'USD',
      DOLLARS: 'USD',
      US: 'USD',
      RUPEE: 'INR',
      RUPEES: 'INR',
    }

    return aliasMap[raw] || raw
  }

  const renderTextValue = (raw: any) => {
    if (raw === null || raw === undefined) return '-'
    if (typeof raw === 'boolean') return raw ? 'Yes' : 'No'
    return String(raw)
  }

  if (value === null || value === undefined) {
    return <span className="text-muted">-</span>
  }

  switch (type) {
    case 'status':
      return (
        <StatusButton
          syncStatus={value}
          syncMessage={syncMessage || row?.sync_message || row?.primary_sync_message}
        />
      )
    
    case 'productName':
      return <ProductNameCell productData={row} />
    
    case 'price': {
      const priceValue = typeof value === 'object' ? value?.value : value
      const objectCurrency = typeof value === 'object' ? value?.currency_iso : ''
      const rowCurrency = row?.currency_iso || row?.platform_product?.currency_iso || ''
      const resolvedCurrency =
        normalizeCurrencyCode(objectCurrency) ||
        normalizeCurrencyCode(rowCurrency) ||
        normalizeCurrencyCode(currency) ||
        normalizeCurrencyCode(platformCurrency) ||
        'USD'
      const currencySymbol = currencySigns[resolvedCurrency as keyof typeof currencySigns] || resolvedCurrency
      const formattedValue = priceValue ? Number(priceValue).toFixed(2) : '0.00'
      return <span>{currencySymbol} {formattedValue}</span>
    }
    
    case 'badge':
      let badgeClass = 'badge-success'
      let displayValue = value

      if (typeof value === 'string' && value.includes('_')) {
        displayValue = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
      } else if (typeof value === 'string') {
        displayValue = value.charAt(0).toUpperCase() + value.slice(1)
      }
      
      return (
        <span className={`badge ${badgeClass} py-2 fs-6`} style={{
          color: 'white',
          borderRadius: '5px',
          border: 'none',
          width: '130px',
          textAlign: 'center'
        }}>
          {displayValue || '-'}
        </span>
      )
    
    case 'date':
      return <span className="text-nowrap">{value}</span>
    
    case 'text':
    default:
      return <span>{renderTextValue(value)}</span>
  }
}
